import { Nullable } from '@enmon/commons';
import { SerializedMeter } from '@enmon/commons/lib/enmon';
import { OtherDeviceCategory } from '@enmon/commons/lib/shared/meter';
import { isNil } from 'rambda';

export const isThermometer = (details: Nullable<SerializedMeter['detail']>) =>
  !isNil(details) && 'deviceCategory' in details && details.deviceCategory === OtherDeviceCategory.Thermometer;
